import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="font-serif text-2xl font-bold text-brand-charcoal mb-6" data-id="element-37">
      Política de Privacidad
    </h3>
    <div className="space-y-4 text-gray-700 leading-relaxed text-sm" data-id="element-38">
      <p data-id="element-39">
        <strong data-id="element-40">Última actualización:</strong> Abril 2026
      </p>
      <p data-id="element-41">
        En Reset Metabólico 45+ nos comprometemos a proteger tu privacidad. Esta
        política describe cómo recopilamos, usamos y protegemos tu información
        personal.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-42">
        1. Información que recopilamos
      </h4>
      <p data-id="element-43">
        Recopilamos únicamente la información necesaria para procesar tu compra:
        nombre, dirección de correo electrónico y datos de pago. No almacenamos
        datos de tarjetas de crédito; estos son procesados de forma segura por
        nuestro proveedor de pagos.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-44">
        2. Uso de la información
      </h4>
      <p data-id="element-45">
        Tu información se utiliza exclusivamente para: enviar el producto
        digital adquirido, brindarte soporte postventa y, si diste tu
        consentimiento, enviarte comunicaciones relacionadas con salud y
        bienestar.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-46">
        3. Protección de datos
      </h4>
      <p data-id="element-47">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-48">
        4. Tus derechos
      </h4>
      <p data-id="element-49">
        Podés solicitar en cualquier momento el acceso, rectificación o
        eliminación de tus datos personales. También podés darte de baja de
        nuestras comunicaciones en cualquier momento.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-50">
        5. Cookies
      </h4>
      <p data-id="element-51">
        Utilizamos cookies esenciales para el funcionamiento del sitio y cookies
        analíticas para mejorar tu experiencia. Podés configurar tu navegador
        para rechazar cookies en cualquier momento.
      </p>
    </div>
  </>;
const termsContent = <>
    <h3 className="font-serif text-2xl font-bold text-brand-charcoal mb-6" data-id="element-52">
      Términos y Condiciones
    </h3>
    <div className="space-y-4 text-gray-700 leading-relaxed text-sm" data-id="element-53">
      <p data-id="element-54">
        <strong data-id="element-55">Última actualización:</strong> Abril 2026
      </p>
      <p data-id="element-56">
        Al adquirir el programa Reset Metabólico 45+, aceptás los siguientes
        términos y condiciones de uso.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-57">
        1. Producto digital
      </h4>
      <p data-id="element-58">
        Reset Metabólico 45+ es un producto digital (ebook en formato PDF) que
        se entrega de forma inmediata tras la confirmación del pago. Por su
        naturaleza digital, no se aceptan devoluciones una vez descargado el
        material.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-59">
        2. Uso personal
      </h4>
      <p data-id="element-60">
        El contenido adquirido es para uso personal y exclusivo del comprador.
        Queda prohibida la reproducción, distribución, reventa o compartición
        del material sin autorización expresa por escrito.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-61">
        3. Descargo de responsabilidad médica
      </h4>
      <p data-id="element-62">
        Este producto tiene fines educativos e informativos. No sustituye el
        consejo, diagnóstico o tratamiento médico profesional. Consultá siempre
        a tu médico antes de realizar cambios en tu alimentación o rutina de
        ejercicio, especialmente si tenés condiciones médicas preexistentes.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-63">
        4. Resultados
      </h4>
      <p data-id="element-64">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos, ya que estos dependen de múltiples factores
        individuales como adherencia al programa, estado de salud previo y
        estilo de vida.
      </p>
      <h4 className="font-bold text-brand-charcoal text-base pt-2" data-id="element-65">
        5. Propiedad intelectual
      </h4>
      <p data-id="element-66">
        Todo el contenido del programa, incluyendo textos, gráficos, diseños y
        metodologías, está protegido por derechos de autor y es propiedad
        exclusiva de Reset Metabólico 45+.
      </p>
    </div>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-charcoal text-white/60 py-12 text-center text-sm" data-id="element-67">
        <div className="container mx-auto px-4" data-id="element-68">
          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-69">
            <button onClick={() => setActiveModal('privacy')} className="text-white/50 hover:text-brand-orange transition-colors underline underline-offset-4 decoration-white/20 hover:decoration-brand-orange" data-id="element-70">
              Política de Privacidad
            </button>
            <span className="text-white/20" data-id="element-71">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/50 hover:text-brand-orange transition-colors underline underline-offset-4 decoration-white/20 hover:decoration-brand-orange" data-id="element-72">
              Términos y Condiciones
            </button>
          </div>
          <p className="mb-4" data-id="element-73">
            © {new Date().getFullYear()} Reset Metabólico 45+. Todos los
            derechos reservados.
          </p>
          <p className="max-w-2xl mx-auto text-xs leading-relaxed opacity-70" data-id="element-74">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa de nutrición o
            ejercicio, especialmente si tiene condiciones médicas preexistentes.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-75">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-76">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-77">
              {/* Modal Header */}
              <div className="flex items-center justify-end p-4 border-b border-gray-100" data-id="element-78">
                <button onClick={() => setActiveModal(null)} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors" aria-label="Cerrar" data-id="element-79">
                  <XIcon className="w-5 h-5 text-gray-600" data-id="element-80" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 md:p-10 overflow-y-auto max-h-[calc(80vh-72px)]" data-id="element-81">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}